import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.notices,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].updateNotice,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Clone',
				id: 'clone',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.notices,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].createNotice,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.notices,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].selectWidgetType,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
